import { apiClient } from '~/api/client';

export type CreateParams = {
  attributes: {
    color: string;
    description: string;
    name: string;
    public: boolean;
    synced: boolean;
  };
  type: ListSTI;
};

export const create = async (params: CreateParams) => apiClient.post('/lists', params);
